export const cssBundleHref = "/build/css-bundle-RUO7CH3G.css";